import { render, staticRenderFns } from "./CategoryDataList.vue?vue&type=template&id=c59a32ec&scoped=true&"
import script from "./CategoryDataList.vue?vue&type=script&lang=js&"
export * from "./CategoryDataList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDataList.vue?vue&type=style&index=0&id=c59a32ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59a32ec",
  null
  
)

export default component.exports